import type { ModuleId } from "@gosaas/modules";
import {
	IconAlertCircle,
	IconBell,
	IconBook,
	IconCreditCard,
	IconFilter,
	IconGauge,
	IconKey,
	IconLock,
	IconPlug,
	IconSettings,
	IconUsers,
	IconUsersGroup,
} from "@tabler/icons-react";

type NavModule = Extract<
	ModuleId,
	"team" | "billing" | "notifications" | "public_api" | "docs"
>;

export const StandardAppNavigation = {
	// Staff-only platform console; rendered only when the user has a staff role.
	admin: [
		{
			title: "Overview",
			url: "/admin",
			icon: IconGauge,
		},
		{
			title: "Users",
			url: "/admin/users",
			icon: IconUsers,
		},
		{
			title: "Teams",
			url: "/admin/teams",
			icon: IconUsersGroup,
		},
	],
	developer: [
		{
			title: "Documentation",
			url: "/docs",
			icon: IconBook,
			module: "docs" as NavModule,
		},
		{
			title: "API reference",
			url: "/docs/api-reference",
			icon: IconKey,
			module: "public_api" as NavModule,
		},
		{
			title: "MCP integration",
			url: "/docs/api-reference/guides/mcp-integration",
			icon: IconPlug,
			requiresMcp: true,
		},
	],
	team: [
		{
			title: "Settings",
			url: "/team/settings",
			permissions: ["account:read"],
			icon: IconSettings,
		},
		{
			title: "Members",
			url: "/team/members",
			permissions: ["members:read"],
			icon: IconUsers,
			hideForPersonal: true,
			module: "team" as NavModule,
		},
		{
			title: "Billing",
			module: "billing" as NavModule,
			permissions: ["billing:read"],
			icon: IconCreditCard,
			useCollapsible: true,
			items: [
				{
					title: "Settings",
					url: "/team/billing",
					permissions: ["billing:read"],
					icon: IconSettings,
				},
				{
					title: "Usage",
					url: "/team/billing/usage",
					permissions: ["billing:read"],
					icon: IconAlertCircle,
				},
			],
		},
		{
			title: "Security",
			url: "/team/security",
			permissions: ["security:read"],
			icon: IconLock,
		},
		{
			title: "API keys",
			url: "/team/settings/api-keys",
			permissions: ["apikeys:read"],
			icon: IconKey,
			module: "public_api" as NavModule,
		},
		{
			title: "Notifications",
			module: "notifications" as NavModule,
			permissions: ["notifications:read"],
			icon: IconBell,
			useCollapsible: true,
			items: [
				{
					title: "Rules",
					url: "/team/notifications/rules",
					permissions: ["notifications:read"],
					icon: IconFilter,
				},
				{
					title: "Channels",
					url: "/team/notifications/channels",
					permissions: ["notifications:read"],
					icon: IconPlug,
				},
			],
		},
	],
};
